<template>
  <component
    :is="icon"
    :width="size"
    :height="size"
    class="hero-icon"
    aria-hidden="true"
  />
</template>

<script>
// Renders a Heroicon imported as a Vue component (via vue-svg-loader), e.g.:
//   import HomeIcon from 'heroicons/24/outline/home.svg'
//   <hero-icon :icon="HomeIcon" :size="22" />
// Heroicons use stroke="currentColor", so set the color via the surrounding `color` CSS.
export default {
  name: 'HeroIcon',

  props: {
    icon: {
      type: [Object, Function],
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    }
  }
}
</script>

<style scoped>
.hero-icon {
  display: inline-block;
  vertical-align: middle;
  flex: none;
}
</style>
